// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FYs3","colBig":"styles_colBig__1Nh4K","colSmall":"styles_colSmall__bZOlX"};